import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';

export type CreateWalletSetupIntentResponse = {
  data: {
    clientSecret: string;
  };
};

export const createWalletSetupIntent = async () => {
  const response = await restClient.request<CreateWalletSetupIntentResponse>('/payment/wallet/setup_intent', { method: 'POST' });

  return response.data;
};

export type ConfirmWalletPaymentInput = {
  paymentMethodId: string;
  resourceIds: null | string[];
};

export type ConfirmWalletPaymentResponse = {
  data: {
    status: string;
    errorCode?: 'card_declined' | 'generic';
    error?: string;
  };
};

export const confirmWalletPayment = async (data: ConfirmWalletPaymentInput) => {
  const response = await restClient.request<ConfirmWalletPaymentResponse>('/payment/wallet/confirm', {
    method: 'POST',
    data: snakecaseKeys(data)
  });

  return response.data;
};
